import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import objectPath from 'object-path'
// import SVG from "react-inlinesvg";
// import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from '../../_core/MetronicLayout'
import { toAbsoluteUrl } from '../../../_helpers'
import { useHistory } from 'react-router-dom'
import { ExitToAppOutlined } from '@material-ui/icons'
import { Button } from '@material-ui/core'

export function HeaderMobile() {
    const uiService = useHtmlClassService()
    const history = useHistory()

    const layoutProps = useMemo(() => {
        return {
            headerLogo: uiService.getStickyLogo(),
            asideDisplay: objectPath.get(
                uiService.config,
                'aside.self.display'
            ),
            headerMenuSelfDisplay:
                objectPath.get(uiService.config, 'header.menu.self.display') ===
                true,
            headerMobileCssClasses: uiService.getClasses('header_mobile', true),
            headerMobileAttributes: uiService.getAttributes('header_mobile'),
        }
    }, [uiService])
    const logoutClick = () => {
        const toggle = document.getElementById('kt_quick_user_toggle')
        if (toggle) {
            toggle.click()
        }
        history.push('/auth/logout')
    }
    return (
        <>
            {/*begin::Header Mobile*/}
            <div
                id="kt_header_mobile"
                className={`header-mobile align-items-center ${layoutProps.headerMobileCssClasses}`}
                {...layoutProps.headerMobileAttributes}
            >
                {/*begin::Toolbar*/}
                {/* <div className="d-flex align-items-center"> */}
                {layoutProps.asideDisplay && (
                    <>
                        {/*begin::Aside Mobile Toggle*/}
                        <button
                            className="btn p-0 burger-icon burger-icon-left"
                            id="kt_aside_mobile_toggle"
                        >
                            <span />
                        </button>
                        {/*end::Aside Mobile Toggle*/}
                    </>
                )}
                {/*begin::Logo*/}
                <Link to="/dashboard">
                    <img alt="logo" src={layoutProps.headerLogo} />
                </Link>
                {/*end::Logo*/}

                {/* {layoutProps.headerMenuSelfDisplay && (
            <>
              <button
                className="btn p-0 burger-icon ml-4"
                id="kt_header_mobile_toggle"
              >
                <span />
              </button>
            </>
          )} */}

                <Button
                    variant="contained"
                    className="h-50 mt-4 btn-bg-gold"
                    // startIcon={<ExitToAppOutlined className="mr-3" />}
                    onClick={logoutClick}
                    // style={{backgroundColor:"#D8B063"}}
                >
                    خروج
                </Button>
            </div>
            {/*end::Toolbar*/}
            {/* </div> */}
            {/*end::Header Mobile*/}
        </>
    )
}
